import {LoginPageStatus} from "./login-page-model";


export function isProcessing(pageStatus: LoginPageStatus): boolean {
    return pageStatus === "Sending";
}

export function isRedirect(pageStatus: LoginPageStatus): boolean {
    return pageStatus === "Redirect";
}

